module.exports = __webpack_public_path__ + "static/media/uiuxdesign.901c5bdb.svg";